import { useChangeNotificationSettings, useNotificationSettings, useNotificationSettingsSaving, useNotificationTypes } from "@/shared/api/notifications";
import NotificationGrid from "@/shared/components/NotificationGrid";
import { Note, Pane } from "@/shared/components/settings-atoms";
import { Switch } from "@/shared/components/ui/switch";

export default function NotificationsSection() {
  const types = useNotificationTypes();
  const settings = useNotificationSettings(null);
  const change = useChangeNotificationSettings(null);
  const saving = useNotificationSettingsSaving();

  return (
    <Pane title="Notifications" desc="Your own settings, for this workspace. Only you see them.">
      <NotificationGrid
        types={types}
        settings={settings}
        disabled={saving}
        renderCell={(cell, name) => (
          <Switch
            aria-label={name}
            disabled={saving}
            checked={cell.enabled}
            onCheckedChange={(on) => change.mutate([{ type: cell.type, channel: cell.channel, value: on ? "on" : "off" }])}
          />
        )}
      />
      <Note>Turning a notice off doesn't hide the work. A run waiting on you still shows in its chat and on Tasks.</Note>
    </Pane>
  );
}
